import React from "react";
import classNames from "classnames";
import { FolderIcon } from "@common/folderIcon";

import { Props } from "./types";
import { ScrollingText } from "@common/scrollingText";
import styles from "./styles.scss";
import { Link, NavLink } from "react-router-dom";

function Project({ project, isSelected }: Props) {
  return (
    <NavLink
      to={`/projects/${project.uuid}`}
      className={({ isActive }) =>
        classNames(styles.project, { [styles.selected]: isActive })
      }
    >
      <div>
        <FolderIcon className={styles.icon} isOpen={isSelected} />
      </div>
      <div className={styles.main}>
        <ScrollingText>
          <h3 className={styles.name}>{project.name}</h3>
        </ScrollingText>
        <p className={styles.tasks}>{project.numberOfElements}</p>
      </div>
    </NavLink>
  );
}

export { Project };
